import type { AccountRiskFactor as AccountRiskFactorModel } from '@/adapters/catalogv1.g';

export function extractAccountRiskFactor(model: AccountRiskFactorModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    riskFactorRef: model.risk_factor_ref ?? '',
    confidence: model.confidence,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountRiskFactor = ReturnType<
  typeof extractAccountRiskFactor
>;
